import ProcurementPage from "./pages/ProcurementPage";

export const procurementRoutes = [
  {
    path: "/procurement",
    element: <ProcurementPage />,
    roles: ["admin", "executive", "chairman", "secretary"],
  },
];
